<template>
  <QuadroPrincipal
    v-if="!!fundo && !!fundo.dados && !!fundo.dados.length"
    :titulo="fundo.nome"
    :classe="classe"
  >
    <RegistrosFundo
      :classe="classe"
      :fundo="fundo"
      :seleciona="seleciona"
      :fundoSelecionado="fundoSelecionado"
      :selecionouFundo="selecionouFundo"
      :edita="edita"
      :loading="loading"
    />

    <!-- SUPÕE-SE QUE APLICA = 2 É QUANDO NÃO HÁ FUNDO NO SIMPLES, necessita-se verificação -->
    <CalculoFundo
      v-if="(fundoSelecionado && fundoSelecionado.aplica != 2) || !fundoSelecionado"
      :selecionouFundo="selecionouFundo"
      :aliquotaEfetivaSelecionada="aliquotaEfetivaSelecionada"
    />
  </QuadroPrincipal>
</template>

<script>
import CalculoFundo from "@/components/CalculoFundo/CalculoFundo.vue";
import RegistrosFundo from "@/components/RegistrosFundo/RegistrosFundo.vue";
import QuadroPrincipal from "@/components/QuadroPrincipal/QuadroPrincipal.vue";
export default {
  name: "FundoIcms",

  props: {
    aliquotaEfetivaSelecionada: String | Number,
    classe: String,
    fundo: Object | Array,
    loading: Boolean,
    seleciona: Function,
    fundoSelecionado: Object,
    selecionouFundo: Boolean,
    edita: Function
  },

  components: {
    CalculoFundo,
    QuadroPrincipal,
    RegistrosFundo
  },

  data() {
    return {};
  },

  created() {
    if (this.fundo && this.fundo.dados && this.fundo.dados.length == 1) {
      this.seleciona(this.fundo.dados[0]);
    }
  },

  // updated() {
  //   if(this.fundo && this.fundo.dados.length == 1) {
  //     this.seleciona(this.fundo.dados[0])
  //   }
  // },

  methods: {}
};
</script>

<style lang="scss" scoped></style>
